module.exports = __webpack_public_path__ + "static/media/backBlue.b95fe811.svg";